import { RSAA, isRSAA } from 'redux-api-middleware';
import { replace } from 'connected-react-router';
import _ from 'lodash';
import { LOGOUT_SUCCESS } from '../services/actions';
import { LOGIN_FAILURE } from 'cm-react/lib/services/auth/Login/actions';
import {
  getCurrentLocale,
  getAccessToken,
  getAuthProvider
} from '../services/reducers';
import * as urls from '../services/urls';

const populateApiCallHeaders = (appState, baseHeaders) => {
  let headers = _.defaults(baseHeaders, {
    'Content-Type': 'application/json',
    'Accept-Language': getCurrentLocale(appState)
  });
  if (baseHeaders && baseHeaders['Content-Type'] === 'multipart/form-data') {
    delete headers['Content-Type'];
  }

  const token = getAccessToken(appState);
  const provider = getAuthProvider(appState);

  if (token) {
    headers['Authorization'] = `Token ${token}`;
    headers['Authorization-Provider'] = provider;
  }
  return headers;
};

export const apiCallModifier = store => next => action => {
  if (isRSAA(action)) {
    const state = store.getState();
    action[RSAA].headers = populateApiCallHeaders(state, action[RSAA].headers);
  }

  return next(action);
};

export const apiResponseMiddleware = store => next => action => {
  if (action.payload && action.payload.status) {
    // forceLogoutMiddleware
    if (action.payload.status === 401 && action.type !== LOGIN_FAILURE) {
      return next({ type: LOGOUT_SUCCESS });
    }

    // notFoundErrorHandler
    if (
      action.payload.status === 404 &&
      action.payload.response.code === 'not_found'
    ) {
      return next(replace(urls.NOT_FOUND_PAGE_URL));
    }
  }

  return next(action);
};
